import React, { useEffect } from 'react'
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import LoginOauth from "../components/Login/LoginOauth";
import Header from "../components/Layout/Header"

const LoginPageOauth = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useSelector((state) => state.user);

  useEffect(() => {
    if(isAuthenticated === true){
      navigate("/");
    }
  }, [])
  
  return (
    <div>
        <Header />
        <LoginOauth />
    </div>
  )
}

export default LoginPageOauth;